<div class="modal-header" mat-dialog-title>
  <div class="modal-header-icon">
    <mat-icon class="material-symbols-outlined">edit</mat-icon>
  </div>
  <div class="modal-header-titles">
    <h2 class="modal-title">Editar movimentação</h2>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn" (click)="fechar()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content">
  <div class="form-grid">
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Data</mat-label>
      <input matInput [matDatepicker]="picker" [(ngModel)]="dataMovimentacao" (input)="onDateInput($event)"
        (keydown)="onDateKeydown($event)" (blur)="onDataMovimentacaoBlur($event)" placeholder="DD/MM/AAAA"
        inputmode="numeric" maxlength="10" [max]="hoje" required />
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Quantidade</mat-label>
      <input matInput type="text" inputmode="decimal" [(ngModel)]="quantidade" [currencyMask]="quantidadeMask"
        [disabled]="temLoteOuSerie"
        [matTooltip]="temLoteOuSerie ? 'Quantidade não pode ser alterada nesta movimentação' : ''"
        placeholder="0,00" required />
    </mat-form-field>
  </div>

  @if (temLoteOuSerie) {
  <app-alert-card type="info">
    Quantidade não pode ser alterada porque esta movimentação está vinculada a
    {{ data.row.idLote ? 'um lote (' + (data.row.codigoLote || '-') + ')' : 'uma série (' + (data.row.codigoSerie ||
    '-') + ')' }}.
  </app-alert-card>
  }

  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
    <mat-label>Observação</mat-label>
    <textarea matInput [(ngModel)]="descricao" rows="3"></textarea>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
  <button mat-stroked-button class="btn-secondary" type="button" [disabled]="isSalvando" (click)="fechar()">
    Cancelar
  </button>
  <button mat-flat-button class="btn-primary" type="button" [disabled]="isSalvando" (click)="salvar()">
    @if (isSalvando) { <mat-spinner diameter="20"></mat-spinner> }
    @else { <span>Salvar</span> }
  </button>
</mat-dialog-actions>
